import axios from "axios";

export const API_URL = "";

const api = axios.create({
  baseURL: "/api"
});

export default api;
